<template>
    <VBottomSheet ref="bts" v-model="value" :spaceTop="120" :scrollable="true">
        <div class="relative -mt-20">
            <div class="px-6 pb-6 text-center">
                <section class="header">
                    <div>
                        <img src="@/assets/ui-phase/dialog-code.png" class="mx-auto" alt />
                    </div>
                    <div class="text-primary mt-6">
                        50 Baht Santa fe Discount
                        for all branch
                    </div>
                </section>
                <section class="mt-3 serial-tabs">
                    <VTabNav v-model="tab" :items="tabs" grow></VTabNav>
                    <VTabItems id="tab-dialog-code" :tab="tab" class="pt-5">
                        <VTabItem>
                            <div
                                class="text-gray-secondary mb-3"
                                v-html="lbl.promotion.body.presentCode"
                            ></div>
                            <div class="text-center">
                                <VueQrcode class="mx-auto" :value="code" :options="{ width: 151 }"></VueQrcode>
                            </div>
                        </VTabItem>
                        <VTabItem>
                            <div
                                class="text-gray-secondary mb-4"
                                v-html="lbl.serial.show_code_at_shop"
                            ></div>
                            <div class="mb-4 mt-10">
                                <div class="text-red-1 text-3xl">{{ code }}</div>
                                <div class="mt-2 text-center">
                                    <button
                                        class="outline-none border border-primary rounded-full text-primary text-xs px-2 py-1"
                                        v-clipboard="code"
                                        v-clipboard:success="onCopySuccess"
                                        v-clipboard:error="onCopyError"
                                    >{{ lbl.serial.copy_code }}</button>
                                </div>
                            </div>
                        </VTabItem>
                    </VTabItems>
                </section>
                <section class="footer">
                    <div class="text-gray-secondary">{{ redeemOn }}</div>

                    <SerialTimer :serialModel="serialModel" @onSerialExpired="onSerialExpired()"></SerialTimer>

                    <div class="mt-4">
                        <a class="underline text-primary">{{ lbl.serial.view_history }}</a>
                    </div>
                    <Footer :hasPoweredBy="hasPoweredBy" />
                </section>
            </div>
            <div class="absolute right-6 mt-20 top-6">
                <img src="@/assets/icon/dialog/close.svg" @click="hide()" class="w-18px h-18px" alt />
            </div>
        </div>
    </VBottomSheet>
</template>
<script>
import VBottomSheet from "@/components/Dialog/BottomSheet.vue"
import VTabNav from "@/components/Tab/TabNav.vue"
import VTabItems from "@/components/Tab/TabItems.vue"
import VTabItem from "@/components/Tab/TabItem.vue"
import VueQrcode from '@chenfengyuan/vue-qrcode'
import SerialTimer from "./component/SerialTimer.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
// helper
import Utility from "@/helper/Utility"
// mixins
import LocaleMixin from "@/mixin/LocaleMixin"

export default {
    name: 'CodeDialog',
    props: {
    },
    components: {
        VBottomSheet,
        VTabNav,
        VTabItems,
        VTabItem,
        VueQrcode,
        SerialTimer,
        Footer
    },
    mixins: [LocaleMixin],
    data: function () {
        return {
            value: false,
            tab: 0,
            code: "12345678901234",
            serialModel: null,
            hasPoweredBy: false,
        }
    },
    computed: {
        redeemOn: function () {
            return Utility.stringFormat(this.lbl.serial.redeem_on, "24/08/20")
        },
        tabs: function () {
            return [this.lbl.serial.qr_code, this.lbl.serial.code];
        }
    },
    created: function () { },
    mounted: function () { },
    methods: {
        show: function (config) {
            this.serialModel = config
            // for test
            this.serialModel = {
                showTimer: true,
                expireIn: 180
            }
            // this.value = true // same expect below code
            this.$refs.bts.show() // recommend to use this style
        },
        hide: function () {
            this.$refs.bts.hide()
        },
        onCopySuccess: function (e) {
            console.log('copied', e.text);
        },
        onCopyError: function (e) {
            console.log('failed', e);
        },
        onSerialExpired: function () {
            // on serial code expired
        }
    }
}
</script>
